import PropTypes from 'prop-types'

const sameProduct = (first, second) => {
  if (first?.product_id && second?.product_id) return String(first.product_id) === String(second.product_id)

  return first?.name && first.name === second?.name
}

const itemDetails = (error, cartItems) => {
  if (error.type === 'shipping_zip_code_invalid') return { label: error.address_label || 'Shipping address' }

  const cartItem = cartItems.find(item => String(item.cart_item_id) === String(error.cart_item_id))
  const label = error.product_name || cartItem?.name || error.sku || 'Item'
  if (!cartItem) return { label }

  const matchingItems = cartItems.filter(item => sameProduct(item, cartItem))
  if (matchingItems.length < 2) return { label }

  const itemNumber = matchingItems.findIndex(item => String(item.cart_item_id) === String(cartItem.cart_item_id)) + 1
  return { label, position: `Item ${itemNumber} of ${matchingItems.length}` }
}

const groupedErrors = errors =>
  errors.reduce((groups, error, index) => {
    const key =
      error.cart_item_id === null || error.cart_item_id === undefined ? `error-${index}` : String(error.cart_item_id)
    const existingGroup = groups.find(group => group.key === key)

    if (existingGroup) {
      existingGroup.errors.push(error)
    } else {
      groups.push({ key, errors: [error] })
    }

    return groups
  }, [])

const CheckoutValidationErrors = ({ errors, cartItems }) => (
  <div className="checkout-validation-errors mf-text-left">
    {errors.every(error => error.type === 'shipping_zip_code_invalid') ? (
      <p className="checkout-validation-errors__context">Correct the shipping ZIP code to continue.</p>
    ) : (
      <>
        <p className="checkout-validation-errors__context">Some bundle selections were not recorded.</p>
        <p className="checkout-validation-errors__action">
          Remove each affected bundle from your cart, then re-add it and choose the required options.
        </p>
      </>
    )}
    <ul className="checkout-validation-errors__items">
      {groupedErrors(errors).map(group => {
        const { label, position } = itemDetails(group.errors[0], cartItems)

        return (
          <li className="checkout-validation-errors__item" key={group.key}>
            <strong className="checkout-validation-errors__product">{label}</strong>
            {position && <span className="checkout-validation-errors__meta">{position}</span>}
            <ul className="checkout-validation-errors__details">
              {group.errors.map((error, index) => (
                <li key={`${error.details?.bundle_group_id || error.message}-${index}`}>{error.message}</li>
              ))}
            </ul>
          </li>
        )
      })}
    </ul>
  </div>
)

CheckoutValidationErrors.propTypes = {
  errors: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      address_label: PropTypes.string,
      cart_item_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      product_name: PropTypes.string,
      sku: PropTypes.string,
      message: PropTypes.string.isRequired
    })
  ).isRequired,
  cartItems: PropTypes.arrayOf(
    PropTypes.shape({
      cart_item_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      product_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      name: PropTypes.string
    })
  ).isRequired
}

export default CheckoutValidationErrors
